<div *ngIf="OBJ_message" id="tig-alert" [ngClass]="{'alert': OBJ_message, 'alert-success': OBJ_message.type === 'success', 'alert-danger': OBJ_message.type === 'error', 'alert-info': OBJ_message.type === 'info'}">
		{{OBJ_message.text | translate}}
	</div>